import {
  Typography,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogTitle,
  IconButton,
  styled,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Stack,
  tableCellClasses,
  Divider,
  Checkbox,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import ToastSnackbar, { SnackbarHandle } from "../../common/ToastNotification";
import { useReactToPrint } from "react-to-print";
import BonafideReportTemplate from "../../templates/BonafideReportTemplate";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#2e186a",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "0rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

interface ProfileDialogProps {
  isOpen: boolean;
  onClose: () => void;
  printData: any;
}

const BonafideReportDialog: React.FC<ProfileDialogProps> = ({
  isOpen,
  onClose,
  printData,
}) => {
  const snackbarRef = useRef<SnackbarHandle>(null);
  const containerRef = useRef();

  const handleDialogClose = (event: object, reason: string) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      // Prevent closing when clicking outside or pressing escape.
      return;
    }
    // Otherwise, call the parent's onClose function.
    onClose();
  };

  const handleDialogPrintBox = useReactToPrint({documentTitle: "ITR"}) as (
    content: () => HTMLElement | null
  ) => () => void;

  const handlePrintCert = () => {
    setTimeout(() => {
      try{
        handleDialogPrintBox(() => containerRef.current!)();
      } catch (error) {
        console.log("Handeling print function call error.");
        console.log(error);
      }
    })
  }


  return (
    <>
      <ToastSnackbar ref={snackbarRef} />
      <Dialog
        open={isOpen}
        onClose={handleDialogClose}
        maxWidth={false}
        sx={{
          display: "flex",
          alignItems: "center", // ✅ Center vertically
          justifyContent: "center", // ✅ Center horizontally
          "& .MuiDialog-paper": {
            width: "56vw", // Set dialog width
            height: "100vh",
            maxWidth: "90vw",
            minHeight: "40vh", // Prevents it from being too short
          },
        }}
      >
        <DialogTitle>
          <Typography variant="h5">
            <strong>Bonafide Report</strong>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            // overflowX: "auto",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "8px", // Width of the scrollbar
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1", // Background of the scrollbar track
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888", // Color of the scroll thumb
              borderRadius: "10px", // Rounded corners
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555", // Darker color on hover for the thumb
            },
          }}
        >
          <Box>
            {/* @ts-ignore */}
            <BonafideReportTemplate ref={containerRef} data={printData}></BonafideReportTemplate>
          </Box>
        </DialogContent>
        <DialogActions  sx={{ alignItems: "center", justifyContent: "center" }}>
            <MyCustomButton onClick={onClose} variant="contained">
              Close
            </MyCustomButton>
            <MyCustomButton onClick={handlePrintCert} variant="contained">
              Print
            </MyCustomButton>
          </DialogActions>
      </Dialog>
    </>
  );
}

export default BonafideReportDialog;